import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { InnerLayoutComponent } from './layouts/inner/inner.component';
import { OuterLayoutComponent } from './layouts/outer/outer.component';
import { LanderLayoutComponent } from './layouts/lander/lander.component';


export const innerRoutes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./views-inner/dash/dash.module').then((m) => m.DashModule),
  },
  {
    path: '',
    loadChildren: () =>
      import('./views-inner/casefile/casefile.module').then((m) => m.CaseFileModule),
  },
  {
    path: 'message',
    loadChildren: () =>
      import('./views-inner/message/message.module').then((m) => m.MessageModule),
  },
  {
    path: 'doc',
    loadChildren: () =>
      import('./views-inner/doc/doc.module').then((m) => m.DocModule),
  },
  {
    path: 'estimate',
    loadChildren: () =>
      import('./views-inner/estimate/estimate.module').then((m) => m.EstimateModule),
  },
  {
    path: 'profile',
    loadChildren: () =>
      import('./views-inner/profile/profile.module').then((m) => m.ProfileModule),
  },
  {
    path: 'starter',
    loadChildren: () =>
      import('./starter/starter.module').then((m) => m.StarterModule),
  },
];

export const authRoutes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./views-outer/auth/auth.module').then((m) => m.AuthModule),
  }
];

export const otherRoutes: Routes = [
  {
    path: '',
    loadChildren: () => import('./views-outer/other/other.module').then((m) => m.OtherModule),
  }
];

export const landerRoutes: Routes = [
  {
    path: '',
    loadChildren: () => import('./views-outer/lander/lander.module').then((m) => m.LanderModule),
  }
];


export const AppRoutes: Routes = [
  {
    path: '',
    component: InnerLayoutComponent,
    children: innerRoutes,
  },
  {
    path: '',
    component: OuterLayoutComponent,
    children: authRoutes,
  },
  {
    path: '',
    component: OuterLayoutComponent,
    children: otherRoutes,
  },
  {
    path: '',
    component: LanderLayoutComponent,
    children: landerRoutes,
  },
  {
    path: '**',
    redirectTo: 'dashboard',
  },
];

export class AppRoutingModule { }
